import React from "react";
import { Link } from "react-router-dom";
import l from "components/util/l";
import { IS_LITE } from "settings";
import SolutionIcon from "components/util/helpers/icons/SolutionIcon";

const FlowsView = ({
  folder,
  flows,
  search,
  onChangeSearch,
  isDeveloper,
  onClickDelete,
  onClickClone,
  onClickUpdate
}) => (
  <div id="start-flows">
    <div id="start-flows-container">

      {(flows.length > 0 || search) && (
        <div id="start-flows-search" className="form-control d-flex align-items-center mb-3">
          <i class="fas fa-search text-muted mr-3"></i>
          <input
            type="text"
            className="border-0 flex-fill"
            placeholder={l("Buscar solución%SB087")}
            value={search}
            onChange={(e) => onChangeSearch(e.target.value)}
          />
          {search && (
            <i
              role="button"
              class="fas fa-times text-muted ml-3"
              onClick={() => onChangeSearch("")}
            ></i>
          )}
        </div>
      )}

      {flows.length > 0 ? (
        <div id="flows" class="w-100">
          <div id="flows-container" class="d-flex flex-wrap">
            {flows.map((flow, index) => (
              <Link
                key={flow.id}
                to={`/?flow_id=${flow.id}`}
                style={{ zIndex: 100 - index }}
                className={"flow " +
                  (flows.length <= 2 ? "large " : " ") +
                  (flow.is_current ? "active " : " ")}>
                <div className="card card-hover-shadow pb-0 px-0 animate__animated animate__fadeIn animate__faster">
                  <div className="d-flex justify-content-between align-items-center mb-0">
                    <div className="mb-1">
                      {flow.is_template && (
                        <span class="badge bg-soft-success text-success p-2 ml-3">{l("Plantilla%SB039")}</span>
                      )}
                      {flow.build_status != "BUILT" && (
                        <span class="badge bg-soft-secondary text-secondary p-2 ml-3">{l("En construcción%SB084")}</span>
                      )}
                      {flow.isUpdateAvailable && (
                        <span class="badge bg-soft-primary text-primary p-2 ml-3">
                          <i class="fas fa-arrow-circle-down mr-1"></i>{l("Actualización disponible%EN054")}
                        </span>
                      )}
                    </div>

                    <div class="btn-group dropdown flow-settings">
                      <button type="button"
                        class="btn btn-lighter text-center dropdown-toggle m-2 rounded-circle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        onClick={e => e.preventDefault()}
                      >
                        <i class="fas fa-ellipsis-v" style={{ fontSize: "1.1em" }}></i>
                      </button>
                      <div class="dropdown-menu pr-1 flow-settings-content">

                        {flow.isUpdateAvailable && isDeveloper && <>
                          <a class="dropdown-item"
                            onClick={e => { e.preventDefault(); onClickUpdate(flow); }}>
                            <i class="fas fa-sync dropdown-item-icon mr-1"></i> {l("Actualizar%AC040")}
                          </a>
                          <hr className="my-2" />
                        </>}

                        {flow.is_owner ? (
                          <>
                            <Link to={`/${flow.id}/edit_flow`} class="dropdown-item">
                              <i class="fas fa-edit dropdown-item-icon mr-1"></i> {l("Editar solución%SB034")}
                            </Link>
                            <Link to={`/${flow.id}/share`} class="dropdown-item">
                              <i class="fas fa-user-group dropdown-item-icon mr-1"></i> {l("Compartir%GA064")}
                            </Link>
                            <div>
                              <hr className="my-2" />

                              <a class="dropdown-item"
                                onClick={e => { e.preventDefault(); onClickClone(flow.id); }}>
                                <i class="tio-copy dropdown-item-icon mr-1"></i> {l("Crear copia%SB041")}
                              </a>

                              <a class="dropdown-item"
                                onClick={e => { e.preventDefault(); onClickDelete(flow); }}>
                                <i class="tio-delete dropdown-item-icon mr-1"></i> {l("Eliminar%GA001")}
                              </a>
                            </div>
                          </>
                        ) : (
                          <>
                            <Link to={`/${flow.id}/edit_flow`} class="dropdown-item">
                              <i class="fas fa-edit dropdown-item-icon mr-1"></i> {l("Editar solución%SB034")}
                            </Link>
                            <a class="dropdown-item"
                              onClick={e => { e.preventDefault(); onClickDelete(flow); }}>
                              <i class="tio-delete dropdown-item-icon mr-1"></i> {l("Eliminar%GA001")}
                            </a>
                          </>
                        )}
                      </div>
                    </div>

                  </div>

                  <div class="flow-content card-body text-center">
                    <SolutionIcon style={{ width: "3rem" }} />

                    <div className="flow-title d-flex align-items-center">
                      <div class="w-100">
                        <h3 className={"flow-name d-flex justify-content-center mt-2 mb-0"}>
                          <div class={(flow.is_current ? "text-primary" : "text-dark") + " h4 text-truncate-2-lines mb-0 px-2"}>
                            {flow.name}
                          </div>
                        </h3>

                        {flow.folder &&
                          <div class="flow-folder w-100">
                            <div className="text-truncate w-100 d-inline-block">
                              <i class="far fa-folder"></i>{flow.folder.name}
                            </div>
                          </div>}
                      </div>
                    </div>

                  </div>

                </div>
              </Link>
            ))

            }
          </div>

          {
            flows.length >= 9 ?
              <div className="w-100">
                <div className="card card-hover-shadow pb-0 px-0 mr-1 mb-2">
                  <Link to={`/settings/flows`} class="text-center w-100">
                    <h3 className={"flow-name mt-0 mb-0"}>
                      <div class="h5 my-2"
                        style={{ color: "#707580" }}>
                        {l("Ver todos%GA060")}
                      </div>
                    </h3>
                  </Link>
                </div>
              </div> : null
          }



        </div>
      ) : (
        <div id="no-flows-content"
          className="card w-100 shadow-none mb-2 animate__animated animate__fadeIn animate__faster"
          style={{ marginTop: "0.75rem" }}>
          <div class="card-body">
            <div className="d-flex flex-column justify-content-center py-7">
              <span id="no-flows-title" className="text-center">
                {search
                  ? l("No se encontraron soluciones%SB088")
                  : l("No tienes soluciones registradas%SB042")}
              </span>
              <div className="d-flex justify-content-center">
                {isDeveloper && !search && !IS_LITE &&
                  <Link to={`/create_flow`} className="btn btn-primary w-50 w-md-25" href="#">
                    <i class="fas fa-plus mr-2"></i>{l("Crear solución%SB033")}
                  </Link>}
                {isDeveloper && !search && IS_LITE &&
                  <Link to="/sync_flow" className="btn btn-primary w-50 w-md-25">
                    <i class="fas fa-sync mr-2"></i>{l("Sincronizar nueva solución%EN040")}
                  </Link>}
              </div>
            </div>
          </div>
        </div>
      )}

    </div>

  </div>
)

export default FlowsView;